"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchEdges = matchEdges;
exports.matchVertices = matchVertices;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Copyright (c) 2017 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


function matchEdges(input, output) {
  var map = {};
  input.forEach(function (edge) {
    map["".concat(edge.from, "\x0B").concat(edge.to)] = edge;
  });
  return output.map(function (le) {
    var edge = map["".concat(le.edge.from, "\x0B").concat(le.edge.to)];

    if (!edge) {
      throw new Error("Unable to find edge for ".concat(le.edge.from, " -> ").concat(le.edge.to));
    }

    return _objectSpread({}, le, {
      edge: edge
    });
  });
}

function matchVertices(input, output) {
  var map = {};
  input.forEach(function (sv) {
    map[String(sv.vertex.key)] = sv.vertex;
  });
  return output.map(function (lv) {
    var vertex = map[String(lv.vertex.key)];

    if (!vertex) {
      throw new Error("Unable to find Vertex for ".concat(lv.vertex.key));
    }

    return _objectSpread({}, lv, {
      vertex: vertex
    });
  });
}